exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".editIcon {\n  color: #3a81f5;\n  font-size: 18px;\n  margin-left: 20px; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// E:/jenkins_home/workspace/_agenda-unco-front-legacy_master/frontend-web/src/app/components/precios-seccion/financiera/new-precio-financiera/new-precio-financiera.component.scss
// module id = ../../../../../src/app/components/precios-seccion/financiera/new-precio-financiera/new-precio-financiera.component.scss
// module chunks = 0